module.exports = __webpack_public_path__ + "static/media/newLogo.16b197bd.png";